@file:OptIn(InternalResourceApi::class)

package quip.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/quip.composeapp.generated.resources/"

public val Res.string.maintenance_type: StringResource by lazy {
      StringResource("string:maintenance_type", "maintenance_type", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4917, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5581, 52),
      ))
    }

public val Res.string.maintenances: StringResource by lazy {
      StringResource("string:maintenances", "maintenances", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4966, 36),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5634, 40),
      ))
    }

public val Res.string.mechanic: StringResource by lazy {
      StringResource("string:mechanic", "mechanic", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 5003, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5675, 28),
      ))
    }

public val Res.string.model: StringResource by lazy {
      StringResource("string:model", "model", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 5032, 21),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5704, 21),
      ))
    }

public val Res.string.motor_section: StringResource by lazy {
      StringResource("string:motor_section", "motor_section", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 5054, 29),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5726, 29),
      ))
    }

public val Res.string.my_spare_part_add_brand_only: StringResource by lazy {
      StringResource("string:my_spare_part_add_brand_only", "my_spare_part_add_brand_only", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 5084, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5756, 64),
      ))
    }

public val Res.string.my_spare_part_compatible_vehicles_header: StringResource by lazy {
      StringResource("string:my_spare_part_compatible_vehicles_header", "my_spare_part_compatible_vehicles_header", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 5141, 76),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5821, 80),
      ))
    }

public val Res.string.my_spare_part_delete_message: StringResource by lazy {
      StringResource("string:my_spare_part_delete_message", "my_spare_part_delete_message", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 5218, 100),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5902, 88),
      ))
    }

public val Res.string.my_spare_part_delete_title: StringResource by lazy {
      StringResource("string:my_spare_part_delete_title", "my_spare_part_delete_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 5319, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5991, 62),
      ))
    }

public val Res.string.my_spare_part_deleted_successfully: StringResource by lazy {
      StringResource("string:my_spare_part_deleted_successfully", "my_spare_part_deleted_successfully", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 5378, 86),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6054, 86),
      ))
    }

public val Res.string.my_spare_part_edit_title_create: StringResource by lazy {
      StringResource("string:my_spare_part_edit_title_create", "my_spare_part_edit_title_create", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 5465, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6141, 59),
      ))
    }

public val Res.string.my_spare_part_edit_title_edit: StringResource by lazy {
      StringResource("string:my_spare_part_edit_title_edit", "my_spare_part_edit_title_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 5525, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6201, 57),
      ))
    }

public val Res.string.my_spare_part_garage_empty: StringResource by lazy {
      StringResource("string:my_spare_part_garage_empty", "my_spare_part_garage_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 5583, 78),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6259, 86),
      ))
    }

public val Res.string.my_spare_part_garage_vehicles_header: StringResource by lazy {
      StringResource("string:my_spare_part_garage_vehicles_header", "my_spare_part_garage_vehicles_header", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 5662, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6346, 72),
      ))
    }

public val Res.string.my_spare_part_invalid_durability: StringResource by lazy {
      StringResource("string:my_spare_part_invalid_durability", "my_spare_part_invalid_durability", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 5727, 88),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6419, 100),
      ))
    }

public val Res.string.my_spare_part_saved_successfully: StringResource by lazy {
      StringResource("string:my_spare_part_saved_successfully", "my_spare_part_saved_successfully", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 5816, 80),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6520, 84),
      ))
    }

public val Res.string.my_spare_part_share_already_shared_message: StringResource by lazy {
      StringResource("string:my_spare_part_share_already_shared_message", "my_spare_part_share_already_shared_message", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 5897, 106),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6605, 102),
      ))
    }

public val Res.string.my_spare_part_share_already_shared_title: StringResource by lazy {
      StringResource("string:my_spare_part_share_already_shared_title", "my_spare_part_share_already_shared_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 6004, 68),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6708, 68),
      ))
    }

public val Res.string.my_spare_part_share_error_generic: StringResource by lazy {
      StringResource("string:my_spare_part_share_error_generic", "my_spare_part_share_error_generic", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 6073, 101),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6777, 97),
      ))
    }

public val Res.string.my_spare_part_share_info: StringResource by lazy {
      StringResource("string:my_spare_part_share_info", "my_spare_part_share_info", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 6175, 240),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6875, 232),
      ))
    }

public val Res.string.my_spare_part_share_search_hint: StringResource by lazy {
      StringResource("string:my_spare_part_share_search_hint", "my_spare_part_share_search_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 6416, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7108, 63),
      ))
    }

public val Res.string.my_spare_part_share_success_message: StringResource by lazy {
      StringResource("string:my_spare_part_share_success_message", "my_spare_part_share_success_message", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 6476, 119),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7172, 115),
      ))
    }

public val Res.string.my_spare_part_share_success_title: StringResource by lazy {
      StringResource("string:my_spare_part_share_success_title", "my_spare_part_share_success_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 6596, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7288, 69),
      ))
    }

public val Res.string.my_spare_part_share_title: StringResource by lazy {
      StringResource("string:my_spare_part_share_title", "my_spare_part_share_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 6662, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7358, 57),
      ))
    }

public val Res.string.my_spare_part_share_users_empty: StringResource by lazy {
      StringResource("string:my_spare_part_share_users_empty", "my_spare_part_share_users_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 6720, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7416, 79),
      ))
    }

public val Res.string.my_spare_part_share_users_error_generic: StringResource by lazy {
      StringResource("string:my_spare_part_share_users_error_generic", "my_spare_part_share_users_error_generic", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 6780, 95),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7496, 99),
      ))
    }

public val Res.string.my_spare_part_unknown: StringResource by lazy {
      StringResource("string:my_spare_part_unknown", "my_spare_part_unknown", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 6876, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7596, 45),
      ))
    }

public val Res.string.my_spare_parts_add_first: StringResource by lazy {
      StringResource("string:my_spare_parts_add_first", "my_spare_parts_add_first", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 6918, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7642, 68),
      ))
    }

public val Res.string.my_spare_parts_all_vehicles: StringResource by lazy {
      StringResource("string:my_spare_parts_all_vehicles", "my_spare_parts_all_vehicles", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 6975, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7711, 63),
      ))
    }

public val Res.string.my_spare_parts_compatible_models: StringResource by lazy {
      StringResource("string:my_spare_parts_compatible_models", "my_spare_parts_compatible_models", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 7027, 68),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7775, 72),
      ))
    }

public val Res.string.my_spare_parts_empty_message: StringResource by lazy {
      StringResource("string:my_spare_parts_empty_message", "my_spare_parts_empty_message", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 7096, 92),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7848, 116),
      ))
    }

public val Res.string.my_spare_parts_empty_title: StringResource by lazy {
      StringResource("string:my_spare_parts_empty_title", "my_spare_parts_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 7189, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7965, 66),
      ))
    }

public val Res.string.my_spare_parts_error_generic: StringResource by lazy {
      StringResource("string:my_spare_parts_error_generic", "my_spare_parts_error_generic", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 7248, 96),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8032, 88),
      ))
    }

public val Res.string.my_spare_parts_search_hint: StringResource by lazy {
      StringResource("string:my_spare_parts_search_hint", "my_spare_parts_search_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 7345, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8121, 58),
      ))
    }

public val Res.string.my_spare_parts_title: StringResource by lazy {
      StringResource("string:my_spare_parts_title", "my_spare_parts_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 7408, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8180, 48),
      ))
    }

public val Res.string.my_spare_parts_vehicle_empty_message: StringResource by lazy {
      StringResource("string:my_spare_parts_vehicle_empty_message", "my_spare_parts_vehicle_empty_message", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 7457, 96),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8229, 104),
      ))
    }

public val Res.string.next_itv_date: StringResource by lazy {
      StringResource("string:next_itv_date", "next_itv_date", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 7554, 33),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8334, 37),
      ))
    }

public val Res.string.next_revision_date: StringResource by lazy {
      StringResource("string:next_revision_date", "next_revision_date", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 7588, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8372, 50),
      ))
    }

public val Res.string.no_spare_parts_registered: StringResource by lazy {
      StringResource("string:no_spare_parts_registered", "no_spare_parts_registered", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 7635, 69),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8423, 73),
      ))
    }

public val Res.string.note_import_action: StringResource by lazy {
      StringResource("string:note_import_action", "note_import_action", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 7705, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8497, 54),
      ))
    }

public val Res.string.note_import_ai_applied: StringResource by lazy {
      StringResource("string:note_import_ai_applied", "note_import_ai_applied", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 7756, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8552, 66),
      ))
    }

public val Res.string.note_import_ai_consent_accept: StringResource by lazy {
      StringResource("string:note_import_ai_consent_accept", "note_import_ai_consent_accept", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 7819, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8619, 45),
      ))
    }

public val Res.string.note_import_ai_consent_decline: StringResource by lazy {
      StringResource("string:note_import_ai_consent_decline", "note_import_ai_consent_decline", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 7865, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8665, 50),
      ))
    }

public val Res.string.note_import_ai_consent_message: StringResource by lazy {
      StringResource("string:note_import_ai_consent_message", "note_import_ai_consent_message", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 7916, 426),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 8716, 418),
      ))
    }

public val Res.string.note_import_ai_consent_title: StringResource by lazy {
      StringResource("string:note_import_ai_consent_title", "note_import_ai_consent_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 8343, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9135, 72),
      ))
    }

public val Res.string.note_import_ai_loading: StringResource by lazy {
      StringResource("string:note_import_ai_loading", "note_import_ai_loading", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 8408, 102),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9208, 102),
      ))
    }

public val Res.string.note_import_ai_privacy: StringResource by lazy {
      StringResource("string:note_import_ai_privacy", "note_import_ai_privacy", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 8511, 170),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9311, 178),
      ))
    }

public val Res.string.note_import_ai_remaining: StringResource by lazy {
      StringResource("string:note_import_ai_remaining", "note_import_ai_remaining", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 8682, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9490, 68),
      ))
    }

public val Res.string.note_import_already_in_garage: StringResource by lazy {
      StringResource("string:note_import_already_in_garage", "note_import_already_in_garage", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 8747, 69),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9559, 57),
      ))
    }

public val Res.string.note_import_alternative: StringResource by lazy {
      StringResource("string:note_import_alternative", "note_import_alternative", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 8817, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9617, 59),
      ))
    }

public val Res.string.note_import_analyze: StringResource by lazy {
      StringResource("string:note_import_analyze", "note_import_analyze", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 8877, 39),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9677, 39),
      ))
    }

public val Res.string.note_import_bulk_apply: StringResource by lazy {
      StringResource("string:note_import_bulk_apply", "note_import_bulk_apply", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 8917, 38),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9717, 42),
      ))
    }

public val Res.string.note_import_bulk_assign_to: StringResource by lazy {
      StringResource("string:note_import_bulk_assign_to", "note_import_bulk_assign_to", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 8956, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9760, 50),
      ))
    }

public val Res.string.note_import_bulk_back_to_note: StringResource by lazy {
      StringResource("string:note_import_bulk_back_to_note", "note_import_bulk_back_to_note", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 9007, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9811, 61),
      ))
    }

public val Res.string.note_import_bulk_banner: StringResource by lazy {
      StringResource("string:note_import_bulk_banner", "note_import_bulk_banner", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 9069, 123),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 9873, 131),
      ))
    }

public val Res.string.note_import_bulk_complete_first: StringResource by lazy {
      StringResource("string:note_import_bulk_complete_first", "note_import_bulk_complete_first", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 9193, 83),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10005, 91),
      ))
    }

public val Res.string.note_import_bulk_confirm_message: StringResource by lazy {
      StringResource("string:note_import_bulk_confirm_message", "note_import_bulk_confirm_message", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 9277, 180),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10097, 180),
      ))
    }

public val Res.string.note_import_bulk_confirm_title: StringResource by lazy {
      StringResource("string:note_import_bulk_confirm_title", "note_import_bulk_confirm_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 9458, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10278, 70),
      ))
    }

public val Res.string.note_import_bulk_create: StringResource by lazy {
      StringResource("string:note_import_bulk_create", "note_import_bulk_create", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 9521, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10349, 59),
      ))
    }

public val Res.string.note_import_bulk_creating: StringResource by lazy {
      StringResource("string:note_import_bulk_creating", "note_import_bulk_creating", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 9577, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10409, 65),
      ))
    }

public val Res.string.note_import_bulk_done_summary: StringResource by lazy {
      StringResource("string:note_import_bulk_done_summary", "note_import_bulk_done_summary", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 9643, 85),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10475, 85),
      ))
    }

public val Res.string.note_import_bulk_done_title: StringResource by lazy {
      StringResource("string:note_import_bulk_done_title", "note_import_bulk_done_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 9729, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10561, 67),
      ))
    }

public val Res.string.note_import_bulk_edit_maintenance: StringResource by lazy {
      StringResource("string:note_import_bulk_edit_maintenance", "note_import_bulk_edit_maintenance", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 9785, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10629, 69),
      ))
    }

public val Res.string.note_import_bulk_edit_spare_part: StringResource by lazy {
      StringResource("string:note_import_bulk_edit_spare_part", "note_import_bulk_edit_spare_part", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 9851, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10699, 60),
      ))
    }

public val Res.string.note_import_bulk_edit_vehicle: StringResource by lazy {
      StringResource("string:note_import_bulk_edit_vehicle", "note_import_bulk_edit_vehicle", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 9912, 53),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10760, 61),
      ))
    }

public val Res.string.note_import_bulk_entry: StringResource by lazy {
      StringResource("string:note_import_bulk_entry", "note_import_bulk_entry", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 10078, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10934, 58),
      ))
    }

public val Res.string.note_import_bulk_entry_subtitle: StringResource by lazy {
      StringResource("string:note_import_bulk_entry_subtitle", "note_import_bulk_entry_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 9966, 111),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10822, 111),
      ))
    }

public val Res.string.note_import_bulk_go_to_garage: StringResource by lazy {
      StringResource("string:note_import_bulk_go_to_garage", "note_import_bulk_go_to_garage", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 10133, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10993, 53),
      ))
    }

public val Res.string.note_import_bulk_intro: StringResource by lazy {
      StringResource("string:note_import_bulk_intro", "note_import_bulk_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 10195, 154),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11047, 138),
      ))
    }

public val Res.string.note_import_bulk_issue_vehicle: StringResource by lazy {
      StringResource("string:note_import_bulk_issue_vehicle", "note_import_bulk_issue_vehicle", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 10438, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11278, 50),
      ))
    }

public val Res.string.note_import_bulk_issue_vehicle_not_selected: StringResource by lazy {
      StringResource("string:note_import_bulk_issue_vehicle_not_selected", "note_import_bulk_issue_vehicle_not_selected", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 10350, 87),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11186, 91),
      ))
    }

public val Res.string.note_import_bulk_missing: StringResource by lazy {
      StringResource("string:note_import_bulk_missing", "note_import_bulk_missing", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 10489, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11329, 48),
      ))
    }

public val Res.string.note_import_bulk_new_vehicle: StringResource by lazy {
      StringResource("string:note_import_bulk_new_vehicle", "note_import_bulk_new_vehicle", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 10542, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11378, 44),
      ))
    }

public val Res.string.note_import_bulk_no_vehicle: StringResource by lazy {
      StringResource("string:note_import_bulk_no_vehicle", "note_import_bulk_no_vehicle", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 10583, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11423, 55),
      ))
    }

public val Res.string.note_import_bulk_nothing_selected: StringResource by lazy {
      StringResource("string:note_import_bulk_nothing_selected", "note_import_bulk_nothing_selected", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 10635, 73),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11479, 77),
      ))
    }

public val Res.string.note_import_bulk_result_blocked_incomplete: StringResource by lazy {
      StringResource("string:note_import_bulk_result_blocked_incomplete", "note_import_bulk_result_blocked_incomplete", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 10709, 90),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11557, 82),
      ))
    }

public val Res.string.note_import_bulk_result_blocked_no_vehicle: StringResource by lazy {
      StringResource("string:note_import_bulk_result_blocked_no_vehicle", "note_import_bulk_result_blocked_no_vehicle", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 10800, 82),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11640, 82),
      ))
    }

public val Res.string.note_import_bulk_result_blocked_vehicle: StringResource by lazy {
      StringResource("string:note_import_bulk_result_blocked_vehicle", "note_import_bulk_result_blocked_vehicle", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 10883, 91),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11723, 87),
      ))
    }

public val Res.string.note_import_bulk_result_created: StringResource by lazy {
      StringResource("string:note_import_bulk_result_created", "note_import_bulk_result_created", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 10975, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11811, 47),
      ))
    }

public val Res.string.note_import_bulk_result_existing: StringResource by lazy {
      StringResource("string:note_import_bulk_result_existing", "note_import_bulk_result_existing", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 11027, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11859, 56),
      ))
    }

public val Res.string.note_import_bulk_result_failed: StringResource by lazy {
      StringResource("string:note_import_bulk_result_failed", "note_import_bulk_result_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 11088, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11916, 46),
      ))
    }

public val Res.string.note_import_bulk_retry_failed: StringResource by lazy {
      StringResource("string:note_import_bulk_retry_failed", "note_import_bulk_retry_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 11135, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 11963, 73),
      ))
    }

public val Res.string.note_import_bulk_unassigned: StringResource by lazy {
      StringResource("string:note_import_bulk_unassigned", "note_import_bulk_unassigned", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 11201, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12037, 51),
      ))
    }

public val Res.string.note_import_camera_action: StringResource by lazy {
      StringResource("string:note_import_camera_action", "note_import_camera_action", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 11253, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12089, 49),
      ))
    }

public val Res.string.note_import_camera_frame_guide: StringResource by lazy {
      StringResource("string:note_import_camera_frame_guide", "note_import_camera_frame_guide", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 11303, 82),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12139, 90),
      ))
    }

public val Res.string.note_import_camera_no_text: StringResource by lazy {
      StringResource("string:note_import_camera_no_text", "note_import_camera_no_text", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 11386, 74),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12230, 82),
      ))
    }

public val Res.string.note_import_camera_permission: StringResource by lazy {
      StringResource("string:note_import_camera_permission", "note_import_camera_permission", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 11461, 97),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12313, 105),
      ))
    }

public val Res.string.note_import_camera_retry: StringResource by lazy {
      StringResource("string:note_import_camera_retry", "note_import_camera_retry", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 11559, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12419, 48),
      ))
    }

public val Res.string.note_import_camera_use_anyway: StringResource by lazy {
      StringResource("string:note_import_camera_use_anyway", "note_import_camera_use_anyway", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 11608, 69),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12468, 77),
      ))
    }

public val Res.string.note_import_confidence_high: StringResource by lazy {
      StringResource("string:note_import_confidence_high", "note_import_confidence_high", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 11678, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12546, 55),
      ))
    }

public val Res.string.note_import_confidence_low: StringResource by lazy {
      StringResource("string:note_import_confidence_low", "note_import_confidence_low", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 11734, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12602, 54),
      ))
    }

public val Res.string.note_import_confidence_medium: StringResource by lazy {
      StringResource("string:note_import_confidence_medium", "note_import_confidence_medium", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 11789, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12657, 57),
      ))
    }

public val Res.string.note_import_counter: StringResource by lazy {
      StringResource("string:note_import_counter", "note_import_counter", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 11851, 39),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12715, 39),
      ))
    }

public val Res.string.note_import_date_approx: StringResource by lazy {
      StringResource("string:note_import_date_approx", "note_import_date_approx", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 11891, 95),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12755, 91),
      ))
    }

public val Res.string.note_import_duplicate_warning: StringResource by lazy {
      StringResource("string:note_import_duplicate_warning", "note_import_duplicate_warning", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 11987, 97),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12847, 89),
      ))
    }

public val Res.string.note_import_entry_subtitle: StringResource by lazy {
      StringResource("string:note_import_entry_subtitle", "note_import_entry_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 12085, 130),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 12937, 134),
      ))
    }

public val Res.string.note_import_entry_title: StringResource by lazy {
      StringResource("string:note_import_entry_title", "note_import_entry_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 12216, 67),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13072, 75),
      ))
    }

public val Res.string.note_import_error_daily_quota: StringResource by lazy {
      StringResource("string:note_import_error_daily_quota", "note_import_error_daily_quota", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 12284, 137),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13148, 141),
      ))
    }

public val Res.string.note_import_error_failed: StringResource by lazy {
      StringResource("string:note_import_error_failed", "note_import_error_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 12422, 132),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13290, 140),
      ))
    }

public val Res.string.note_import_error_generic: StringResource by lazy {
      StringResource("string:note_import_error_generic", "note_import_error_generic", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 12555, 89),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 13431, 97),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("maintenance_type", Res.string.maintenance_type)
  map.put("maintenances", Res.string.maintenances)
  map.put("mechanic", Res.string.mechanic)
  map.put("model", Res.string.model)
  map.put("motor_section", Res.string.motor_section)
  map.put("my_spare_part_add_brand_only", Res.string.my_spare_part_add_brand_only)
  map.put("my_spare_part_compatible_vehicles_header", Res.string.my_spare_part_compatible_vehicles_header)
  map.put("my_spare_part_delete_message", Res.string.my_spare_part_delete_message)
  map.put("my_spare_part_delete_title", Res.string.my_spare_part_delete_title)
  map.put("my_spare_part_deleted_successfully", Res.string.my_spare_part_deleted_successfully)
  map.put("my_spare_part_edit_title_create", Res.string.my_spare_part_edit_title_create)
  map.put("my_spare_part_edit_title_edit", Res.string.my_spare_part_edit_title_edit)
  map.put("my_spare_part_garage_empty", Res.string.my_spare_part_garage_empty)
  map.put("my_spare_part_garage_vehicles_header", Res.string.my_spare_part_garage_vehicles_header)
  map.put("my_spare_part_invalid_durability", Res.string.my_spare_part_invalid_durability)
  map.put("my_spare_part_saved_successfully", Res.string.my_spare_part_saved_successfully)
  map.put("my_spare_part_share_already_shared_message", Res.string.my_spare_part_share_already_shared_message)
  map.put("my_spare_part_share_already_shared_title", Res.string.my_spare_part_share_already_shared_title)
  map.put("my_spare_part_share_error_generic", Res.string.my_spare_part_share_error_generic)
  map.put("my_spare_part_share_info", Res.string.my_spare_part_share_info)
  map.put("my_spare_part_share_search_hint", Res.string.my_spare_part_share_search_hint)
  map.put("my_spare_part_share_success_message", Res.string.my_spare_part_share_success_message)
  map.put("my_spare_part_share_success_title", Res.string.my_spare_part_share_success_title)
  map.put("my_spare_part_share_title", Res.string.my_spare_part_share_title)
  map.put("my_spare_part_share_users_empty", Res.string.my_spare_part_share_users_empty)
  map.put("my_spare_part_share_users_error_generic", Res.string.my_spare_part_share_users_error_generic)
  map.put("my_spare_part_unknown", Res.string.my_spare_part_unknown)
  map.put("my_spare_parts_add_first", Res.string.my_spare_parts_add_first)
  map.put("my_spare_parts_all_vehicles", Res.string.my_spare_parts_all_vehicles)
  map.put("my_spare_parts_compatible_models", Res.string.my_spare_parts_compatible_models)
  map.put("my_spare_parts_empty_message", Res.string.my_spare_parts_empty_message)
  map.put("my_spare_parts_empty_title", Res.string.my_spare_parts_empty_title)
  map.put("my_spare_parts_error_generic", Res.string.my_spare_parts_error_generic)
  map.put("my_spare_parts_search_hint", Res.string.my_spare_parts_search_hint)
  map.put("my_spare_parts_title", Res.string.my_spare_parts_title)
  map.put("my_spare_parts_vehicle_empty_message", Res.string.my_spare_parts_vehicle_empty_message)
  map.put("next_itv_date", Res.string.next_itv_date)
  map.put("next_revision_date", Res.string.next_revision_date)
  map.put("no_spare_parts_registered", Res.string.no_spare_parts_registered)
  map.put("note_import_action", Res.string.note_import_action)
  map.put("note_import_ai_applied", Res.string.note_import_ai_applied)
  map.put("note_import_ai_consent_accept", Res.string.note_import_ai_consent_accept)
  map.put("note_import_ai_consent_decline", Res.string.note_import_ai_consent_decline)
  map.put("note_import_ai_consent_message", Res.string.note_import_ai_consent_message)
  map.put("note_import_ai_consent_title", Res.string.note_import_ai_consent_title)
  map.put("note_import_ai_loading", Res.string.note_import_ai_loading)
  map.put("note_import_ai_privacy", Res.string.note_import_ai_privacy)
  map.put("note_import_ai_remaining", Res.string.note_import_ai_remaining)
  map.put("note_import_already_in_garage", Res.string.note_import_already_in_garage)
  map.put("note_import_alternative", Res.string.note_import_alternative)
  map.put("note_import_analyze", Res.string.note_import_analyze)
  map.put("note_import_bulk_apply", Res.string.note_import_bulk_apply)
  map.put("note_import_bulk_assign_to", Res.string.note_import_bulk_assign_to)
  map.put("note_import_bulk_back_to_note", Res.string.note_import_bulk_back_to_note)
  map.put("note_import_bulk_banner", Res.string.note_import_bulk_banner)
  map.put("note_import_bulk_complete_first", Res.string.note_import_bulk_complete_first)
  map.put("note_import_bulk_confirm_message", Res.string.note_import_bulk_confirm_message)
  map.put("note_import_bulk_confirm_title", Res.string.note_import_bulk_confirm_title)
  map.put("note_import_bulk_create", Res.string.note_import_bulk_create)
  map.put("note_import_bulk_creating", Res.string.note_import_bulk_creating)
  map.put("note_import_bulk_done_summary", Res.string.note_import_bulk_done_summary)
  map.put("note_import_bulk_done_title", Res.string.note_import_bulk_done_title)
  map.put("note_import_bulk_edit_maintenance", Res.string.note_import_bulk_edit_maintenance)
  map.put("note_import_bulk_edit_spare_part", Res.string.note_import_bulk_edit_spare_part)
  map.put("note_import_bulk_edit_vehicle", Res.string.note_import_bulk_edit_vehicle)
  map.put("note_import_bulk_entry", Res.string.note_import_bulk_entry)
  map.put("note_import_bulk_entry_subtitle", Res.string.note_import_bulk_entry_subtitle)
  map.put("note_import_bulk_go_to_garage", Res.string.note_import_bulk_go_to_garage)
  map.put("note_import_bulk_intro", Res.string.note_import_bulk_intro)
  map.put("note_import_bulk_issue_vehicle", Res.string.note_import_bulk_issue_vehicle)
  map.put("note_import_bulk_issue_vehicle_not_selected", Res.string.note_import_bulk_issue_vehicle_not_selected)
  map.put("note_import_bulk_missing", Res.string.note_import_bulk_missing)
  map.put("note_import_bulk_new_vehicle", Res.string.note_import_bulk_new_vehicle)
  map.put("note_import_bulk_no_vehicle", Res.string.note_import_bulk_no_vehicle)
  map.put("note_import_bulk_nothing_selected", Res.string.note_import_bulk_nothing_selected)
  map.put("note_import_bulk_result_blocked_incomplete", Res.string.note_import_bulk_result_blocked_incomplete)
  map.put("note_import_bulk_result_blocked_no_vehicle", Res.string.note_import_bulk_result_blocked_no_vehicle)
  map.put("note_import_bulk_result_blocked_vehicle", Res.string.note_import_bulk_result_blocked_vehicle)
  map.put("note_import_bulk_result_created", Res.string.note_import_bulk_result_created)
  map.put("note_import_bulk_result_existing", Res.string.note_import_bulk_result_existing)
  map.put("note_import_bulk_result_failed", Res.string.note_import_bulk_result_failed)
  map.put("note_import_bulk_retry_failed", Res.string.note_import_bulk_retry_failed)
  map.put("note_import_bulk_unassigned", Res.string.note_import_bulk_unassigned)
  map.put("note_import_camera_action", Res.string.note_import_camera_action)
  map.put("note_import_camera_frame_guide", Res.string.note_import_camera_frame_guide)
  map.put("note_import_camera_no_text", Res.string.note_import_camera_no_text)
  map.put("note_import_camera_permission", Res.string.note_import_camera_permission)
  map.put("note_import_camera_retry", Res.string.note_import_camera_retry)
  map.put("note_import_camera_use_anyway", Res.string.note_import_camera_use_anyway)
  map.put("note_import_confidence_high", Res.string.note_import_confidence_high)
  map.put("note_import_confidence_low", Res.string.note_import_confidence_low)
  map.put("note_import_confidence_medium", Res.string.note_import_confidence_medium)
  map.put("note_import_counter", Res.string.note_import_counter)
  map.put("note_import_date_approx", Res.string.note_import_date_approx)
  map.put("note_import_duplicate_warning", Res.string.note_import_duplicate_warning)
  map.put("note_import_entry_subtitle", Res.string.note_import_entry_subtitle)
  map.put("note_import_entry_title", Res.string.note_import_entry_title)
  map.put("note_import_error_daily_quota", Res.string.note_import_error_daily_quota)
  map.put("note_import_error_failed", Res.string.note_import_error_failed)
  map.put("note_import_error_generic", Res.string.note_import_error_generic)
}
